import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=1473515a&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=ts"
export * from "./couponList.vue?vue&type=script&lang=ts"
import style0 from "./couponList.vue?vue&type=style&index=0&id=1473515a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473515a",
  null
  
)

export default component.exports